"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DefaultLogo = function (props) { return (react_1.default.createElement("svg", __assign({ id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 156 156" }, props),
    react_1.default.createElement("title", null, "no-logo-1"),
    react_1.default.createElement("g", { id: "no-logo-1" },
        react_1.default.createElement("g", { id: "icon-building" },
            react_1.default.createElement("rect", { id: "Frame", width: "156", height: "156", rx: "20", fill: "#f0f0f0" }),
            react_1.default.createElement("path", { id: "Shape", d: "M118.12,29a4.49,4.49,0,0,1,4.48,4.27v88.85a4.48,4.48,0,0,1-4.27,4.48H37.48A4.49,4.49,0,0,1,33,122.33V33.48A4.49,4.49,0,0,1,37.27,29h80.85ZM86.28,104.68h-17v13h17ZM113.64,38H42v79.68h18.4V100.2a4.49,4.49,0,0,1,4.27-4.48H90.76A4.5,4.5,0,0,1,95.24,100v17.65h18.4Zm-13.84,33v9h-9v-9Zm-17.92,0v9h-9v-9ZM64,70.92v9H55v-9ZM81.88,53v9h-9V53ZM99.8,53v9h-9V53ZM64,53v9H55V53Z", fill: "#a3a3a3" }))))); };
exports.default = DefaultLogo;
//# sourceMappingURL=DefaultLogo.js.map